import React, { createRef, PureComponent, useLayoutEffect } from 'react';
import PhoneNumberInputView from 'design-system/PhoneNumberInputView';
import { extractCountryCode } from 'utils/validation';
import { noop } from 'lodash';
import { AppView } from 'design-system';
import useColors from 'hooks/useColors';
import StatusBar from 'design-system/StatusBar';
import { KeyboardAvoidingContainerNew } from 'design-system/KeyboardAvoidingContainerNew';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
import prefixes from '../login/sms/prefixes';
import { isWeb } from '../constants';
// like PhoneVerification, but universal
class PhoneFieldPageClass extends PureComponent {
    textinput = createRef();
    constructor(props) {
        super(props);
        let code = 'GB';
        let prefix = '+44';
        const { countryCode } = props.route.params;
        const { defaultValue } = props.route.params;
        if (countryCode) {
            for (const country in prefixes) {
                if (prefixes[country].iso2 === countryCode) {
                    code = prefixes[country].iso2;
                    prefix = prefixes[country].prefix;
                }
            }
            if (defaultValue) {
                const defaultValueWithoutSpaces = defaultValue.replace(/\s/g, '');
                if (defaultValueWithoutSpaces.startsWith(prefix)) {
                    // remove prefix from phone number, it should not be there
                    this.state = {
                        phoneNumber: defaultValueWithoutSpaces.substring(prefix.length),
                        isSendingNumber: false,
                        selectedCountry: { prefix, code },
                    };
                    return;
                }
            }
            this.state = {
                phoneNumber: defaultValue || undefined,
                isSendingNumber: false,
                selectedCountry: { prefix, code },
            };
            return;
        }
        if (defaultValue) {
            const defaultValueWithoutSpaces = defaultValue.replace(/\s/g, '');
            // countryCode was not specified. We need to figure it out ourselves, using google-libphonenumber
            const guessedCountryCode = extractCountryCode(defaultValueWithoutSpaces);
            if (guessedCountryCode) {
                const prefixesArray = Object.values(prefixes);
                const matchingPrefixIndex = prefixesArray.findIndex((prefix) => prefix.iso2 === guessedCountryCode);
                if (matchingPrefixIndex !== -1) {
                    code = prefixesArray[matchingPrefixIndex].iso2;
                    prefix = prefixesArray[matchingPrefixIndex].prefix;
                    this.state = {
                        phoneNumber: defaultValueWithoutSpaces.substring(prefix.length),
                        isSendingNumber: false,
                        selectedCountry: { prefix, code },
                    };
                    return;
                }
                // the country code was detected, however we don’t support that country code
            }
            // the country code was either not detected or we don’t support it
        }
        // the default value was not provided, or the country code was either not detected or we don’t support it
        this.state = {
            phoneNumber: undefined, // don’t prefill anything in this case, because the country code would possibly be incorrect
            isSendingNumber: false,
            selectedCountry: { prefix, code },
        };
    }
    _setFetching = (val) => {
        this.setState({ isSendingNumber: val });
    };
    _onChangeText = (data) => {
        this.setState({ phoneNumber: data });
    };
    _onSelectedPrefix = (data) => {
        const { item } = data;
        const { prefix, iso2 } = item;
        this.setState({ selectedCountry: { code: iso2, prefix } });
        if (this.textinput?.current?.focus) {
            this.textinput.current.focus();
        }
    };
    _renderContent = () => {
        const placeholder = this.props.route.params.placeholder || '';
        const onPressNext = this.props.route.params.onPressNext || noop;
        const { selectedCountry, phoneNumber } = this.state;
        const { code, prefix } = selectedCountry;
        const handlePress = () => {
            onPressNext(prefix + phoneNumber, this._setFetching);
        };
        return (<>
        <KeyboardAvoidingContainerNew flexContainer>
          <PhoneNumberInputView code={code} prefix={prefix} textInputRef={this.textinput} onChangeText={this._onChangeText} placeholder={placeholder || ''} value={this.state.phoneNumber || null} onSubmitEditing={handlePress} onSelectedPrefix={this._onSelectedPrefix}/>
        </KeyboardAvoidingContainerNew>
        <KeyboardAvoidingButton brand isFetching={this.state.isSendingNumber} onPress={handlePress} title={this.props.route.params.buttonTitle || 'Continue'} withFrame={false}/>
      </>);
    };
    render() {
        return (<AppView type="primary" avoidHeader={isWeb}>
        <StatusBar barStyle="dark-content" animated/>
        {this._renderContent()}
      </AppView>);
    }
}
const PhoneFieldPage = (props) => {
    const colors = useColors();
    useLayoutEffect(() => {
        props.navigation.setOptions({
            title: props.route.params.title,
            headerTintColor: colors.text.primary,
        });
    }, [
        colors.text.primary,
        colors.text.white,
        props.navigation,
        props.route.params.title,
    ]);
    return <PhoneFieldPageClass {...props}/>;
};
export default PhoneFieldPage;
